export enum LifeRoutes {
    Root = "/mis-seguros/pga/vida",
    InsuranceDetailV1 = "/v1/#/pga/vida/:productCode/detalle-poliza/:systemCode/:policyId",
    InsuranceDetail = "/mis-seguros/pga/vida/:productCode/detalle-poliza/:systemCode/:policyId",
    InsuranceInfo = "/mis-seguros/pga/vida/:productCode/detalle-poliza/:systemCode/:policyId/info",
    InsuranceInfoDetail = "/mis-seguros/pga/vida/:productCode/detalle-poliza/:systemCode/:policyId/info/:detail",
    InsuranceCoverages = "/mis-seguros/pga/vida/:productCode/coberturas/:systemCode/:policyId",
    InsuranceCoverage = "/mis-seguros/pga/vida/:productCode/coberturas/:systemCode/:policyId/cobertura/:coverageId",
    InsuranceExclusion = "/mis-seguros/pga/vida/:productCode/coberturas/:systemCode/:policyId/exclusion/:coverageId",
    InsurancePayments = "/v1/#/pga/vida/:productCode/mis-pagos/:systemCode/:policyId",
    LIFE_IN155_IN113 = "/mis-seguros/pga/vida/:productCode/detalle-poliza/:systemCode/:policyId",
}
